import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/TheLogin'
import Home from '@/pages/Home'
import Tarefas from '@/pages/tarefas/Tarefas'
import Documentos from '@/pages/Documentos'
import Contatos from '@/pages/contatos/Contatos'
import Contato from '@/pages/contatos/Contato'
import OportunidadesFechadas from '@/pages/oportunidades/fechadas/Fechadas'
import OportunidadesAberto from '@/pages/oportunidades/abertas/Abertas'
import OportunidadesPerdidas from '@/pages/oportunidades/perdidas/Perdidas'
import OportunidadeInterna from '@/pages/oportunidades/Interna'
import Relatorios from '@/pages/relatorios/Relatorios'
import RelatorioFinanciamento from '@/pages/relatorios/financeiros/RelatorioFinanciamento'
import RelatorioOportunidadesGeradas from '@/pages/relatorios/comerciais/RelatorioOportunidadesGeradas'
import RelatorioOrcamentosGerados from '@/pages/relatorios/comerciais/RelatorioOrcamentosGerados'
import RelatorioPropostasGeradas from '@/pages/relatorios/comerciais/RelatorioPropostasGeradas'
import Grupos from '@/pages/configuracoes/Grupos'
import Usuarios from '@/pages/configuracoes/Usuarios'
import Parceiros from '@/pages/configuracoes/Parceiros'
import Bancos from '@/pages/configuracoes/Bancos'
import Banners from '@/pages/configuracoes/Banners'
import Instagram from '@/pages/configuracoes/Instagram'
import Funil from '@/pages/configuracoes/Funil'
import OpcoesFinanciamento from '@/pages/configuracoes/OpcoesFinanciamento'
import TemplateProposta from '@/pages/configuracoes/TemplateProposta'
import Marcas from '@/pages/configuracoes/Marcas'
import Categorias from '@/pages/configuracoes/Categorias'
import Kits from '@/pages/configuracoes/Kits'
import TiposEstrutura from '@/pages/configuracoes/TiposEstrutura'
import Modelos from '@/pages/configuracoes/Modelos'
import Distribuidores from '@/pages/gestor/Distribuidores'
import Integradores from '@/pages/gestor/Integradores'
import Revendedores from '@/pages/gestor/Revendedores'
import InstagramLista from '@/pages/InstagramLista'
import Financiamento from '@/pages/Financiamento'
import DistribuidoresLista from '@/pages/DistribuidoresLista'
import Produtos from '@/pages/produtos/Produtos'
import Orcamentos from '@/pages/Orcamentos'
import PropostaWeb from '@/pages/PropostaWeb'
import Auditoria from '@/pages/auditoria/Auditoria'
import ExportPdf from '@/components/ExportPdf.vue'
import { validToken } from '@config/token'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
Vue.use(NProgress)
NProgress.configure({
  showSpinner: false
})

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tarefas',
      name: 'Tarefas',
      component: Tarefas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/documentos',
      name: 'Documentos',
      component: Documentos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/contatos',
      name: 'Contatos',
      component: Contatos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/contatos/:uuid',
      name: 'Contato',
      component: Contato,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/oportunidades/fechadas',
      name: 'OportunidadesFechadas',
      component: OportunidadesFechadas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/oportunidades/aberto',
      name: 'OportunidadesAberto',
      component: OportunidadesAberto,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/oportunidades/perdidas',
      name: 'OportunidadesPerdidas',
      component: OportunidadesPerdidas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/oportunidade/:uuid',
      name: 'OportunidadeInterna',
      component: OportunidadeInterna,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios',
      name: 'Relatorios',
      component: Relatorios,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/financiamento',
      name: 'RelatorioFinanciamento',
      component: RelatorioFinanciamento,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/orcamentos-gerados',
      name: 'RelatorioOrcamentosGerados',
      component: RelatorioOrcamentosGerados,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/propostas-geradas',
      name: 'RelatorioPropostasGeradas',
      component: RelatorioPropostasGeradas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/oportunidades-geradas',
      name: 'RelatorioOportunidadesGeradas',
      component: RelatorioOportunidadesGeradas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/grupos',
      name: 'Grupos',
      component: Grupos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/usuarios',
      name: 'Usuarios',
      component: Usuarios,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/parceiros',
      name: 'Parceiros',
      component: Parceiros,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/bancos',
      name: 'Bancos',
      component: Bancos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/banners',
      name: 'Banners',
      component: Banners,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/instagram',
      name: 'Instagram',
      component: Instagram,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/funil-de-oportunidades',
      name: 'Funil',
      component: Funil,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/opcoes-financiamento',
      name: 'OpcoesFinanciamento',
      component: OpcoesFinanciamento,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/template-proposta',
      name: 'TemplateProposta',
      component: TemplateProposta,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/categorias',
      name: 'Categorias',
      component: Categorias,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/kits',
      name: 'Kits',
      component: Kits,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/marcas',
      name: 'Marcas',
      component: Marcas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/modelos',
      name: 'Modelos',
      component: Modelos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/tipos-estrutura',
      name: 'TiposEstrutura',
      component: TiposEstrutura,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/gestor/distribuidores',
      name: 'Distribuidores',
      component: Distribuidores,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/gestor/integradores',
      name: 'Integradores',
      component: Integradores,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/gestor/revendedores',
      name: 'Revendedores',
      component: Revendedores,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/instagram-imagens',
      name: 'InstagramLista',
      component: InstagramLista,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/financiamento',
      name: 'Financiamento',
      component: Financiamento,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/distribuidores',
      name: 'DistribuidoresLista',
      component: DistribuidoresLista,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/produtos',
      name: 'Produtos',
      component: Produtos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orcamentos',
      name: 'Orcamentos',
      component: Orcamentos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/auditoria',
      name: 'Auditoria',
      component: Auditoria,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/proposta-web/:uuid',
      name: 'PropostaWeb',
      component: PropostaWeb,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/export-to-pdf',
      name: 'ExportPdf',
      component: ExportPdf,
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  NProgress.set(0.1)
  let userData = localStorage.getItem('userData')
  let user = localStorage.getItem('user')
  let token = localStorage.getItem('token')
  let loggedout = (!userData || !user || !token || !validToken())
  if (!loggedout && (to.name === 'Login' || to.name === 'LoginUuid')) {
    next({ name: 'Home' })
  }
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (loggedout) {
      localStorage.removeItem('userData')
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      NProgress.done()
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.set(0.9)
  // NProgress.done()
  setTimeout(() => NProgress.done(), 500)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js